import { PageHeader, PageBody } from "@/components/PageShell";
import { BarChart3 } from "lucide-react";

export default function AnalyticsPage() {
  return (
    <>
      <PageHeader icon={BarChart3} title="Analytics" subtitle="Funnel, revenue, top performers." testid="analytics-header" />
      <PageBody>
        <div className="ap-panel p-10 text-center" data-testid="analytics-coming-soon">
          <BarChart3 className="h-10 w-10 text-zinc-700 mx-auto mb-3" />
          <div className="text-sm text-zinc-300">Coming in Phase 6</div>
          <div className="text-xs text-zinc-500 mt-2 max-w-md mx-auto leading-relaxed">
            We don't fake numbers. Once we wire postback events from your affiliate networks (Phase 5)
            and have enough click data, this page will surface conversion funnels, top videos and revenue per platform.
          </div>
        </div>
      </PageBody>
    </>
  );
}
